import { AutoPlay, LoopPlay, MediaConfigType, RichMediaShowType } from '@/const/richMedia';

export const RichMediaShowTypeMap: { [key: number]: string } = {
  [RichMediaShowType.SHOW_TYPE_DEFAULT]: '默认展示',
  [RichMediaShowType.SHOW_TYPE_FULLSCREEN]: '全屏展示',
  [RichMediaShowType.SHOW_TYPE_INLINE]: '居中展示',
  [RichMediaShowType.SHOW_TYPE_DRAGGABLE]: '滑动展示',
};

const richMediaPic = [
  {
    render: 'radio',
    label: '展示类别',
    props: 'showType',
    options: [
      {
        label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_DEFAULT],
        value: RichMediaShowType.SHOW_TYPE_DEFAULT,
      },
      {
        label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_FULLSCREEN],
        value: RichMediaShowType.SHOW_TYPE_FULLSCREEN,
      },
      {
        label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_INLINE],
        value: RichMediaShowType.SHOW_TYPE_INLINE,
      },
      {
        label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_DRAGGABLE],
        value: RichMediaShowType.SHOW_TYPE_DRAGGABLE,
      },
    ],
  },
];

const richMediaVideo = [
  // {
  //   render: 'radio',
  //   label: '展示类别',
  //   props: 'showType',
  //   options: [
  //     {
  //       label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_DEFAULT],
  //       value: RichMediaShowType.SHOW_TYPE_DEFAULT,
  //     },
  //     {
  //       label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_FULLSCREEN],
  //       value: RichMediaShowType.SHOW_TYPE_FULLSCREEN,
  //     },
  //     {
  //       label: RichMediaShowTypeMap[RichMediaShowType.SHOW_TYPE_INLINE],
  //       value: RichMediaShowType.SHOW_TYPE_INLINE,
  //     },
  //   ],
  // },
  {
    render: 'switch',
    label: '自动播放',
    props: 'autoPlay',
    options: [
      { label: '是', value: AutoPlay.AUTO_PLAY_TRUE },
      { label: '否', value: AutoPlay.AUTO_PLAY_FALSE },
    ],
  },
];
const richMediaAudio = [
  // {
  //   label: '自动播放',
  //   render: 'switch',
  //   props: 'autoPlay',
  //   options: [
  //     { label: '是', value: AutoPlay.AUTO_PLAY_TRUE },
  //     { label: '否', value: AutoPlay.AUTO_PLAY_FALSE },
  //   ],
  // },
  {
    render: 'switch',
    label: '循环播放',
    props: 'loopPlay',
    options: [
      { label: '是', value: LoopPlay.AUTO_PLAY_TRUE },
      { label: '否', value: LoopPlay.AUTO_PLAY_FALSE },
    ],
  },
];

const config: { [key in MediaConfigType]: any[] } = {
  [MediaConfigType.default]: [],
  [MediaConfigType.File]: [],
  [MediaConfigType.PIC]: richMediaPic,
  [MediaConfigType.VIDEO]: richMediaVideo,
  [MediaConfigType.AUDIO]: richMediaAudio,
  [MediaConfigType.SPINE]: [],
  [MediaConfigType.ARRAY]: [],
};

export const getMediaConfig = (richMediaConfigType: MediaConfigType) => config[richMediaConfigType];
